import { Component, PropSync, Vue } from "vue-property-decorator";

@Component<Hint>({
  components: {}
})
export default class Hint extends Vue {
  @PropSync("show", { type: Boolean })
  syncedShow!: boolean;
  @PropSync("message", { type: String })
  syncedMessage!: string;

  private close() {
    this.$emit("closeHint");
  }
}
